import { gql } from '@apollo/client';

export const STASHLINK_EXIST = gql`
  query ($campaignId: ID!) {
    hasCreatedStashlinkBefore(
      campaignId: $campaignId
    )
  }
`;